import { HTMLAttributes } from "react"

export default function VueJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7489 3.52238L18.3747 3.52575L24.0132 12.885L29.6318 3.5265L38.25 3.52425L24.0563 28.1449L9.7489 3.52238Z"
        fill="#35495E"
      />
      <path
        d="M0.341309 3.58838L9.74143 3.52388L24.0477 28.146L38.2426 3.52538L47.6588 3.53513L24.0466 44.0576L0.341309 3.58838Z"
        fill="#41B883"
      />
    </svg>
  )
}
